export const withCarriedParams = (to: string, search: string, keys: readonly string[]): string => {
  const current = new URLSearchParams(search);
  const carried = keys.flatMap((key) => {
    const value = current.get(key);
    return value ? [[key, value] as const] : [];
  });
  if (carried.length === 0) return to;
  const fragmentStart = to.indexOf('#');
  const fragment = fragmentStart === -1 ? '' : to.slice(fragmentStart);
  const target = fragmentStart === -1 ? to : to.slice(0, fragmentStart);
  const queryStart = target.indexOf('?');
  const path = queryStart === -1 ? target : target.slice(0, queryStart);
  const params = new URLSearchParams(queryStart === -1 ? '' : target.slice(queryStart + 1));
  carried.forEach(([key, value]) => params.set(key, value));
  return `${path}?${params}${fragment}`;
};
